import { MdDeleteOutline, MdOutlineCheckCircle } from 'react-icons/md'
import { Box, Button, Flex, HStack, Heading, Select, Spacer } from '@chakra-ui/react'

const DeleteButton = ({ onClick }) => {
  return (
    <Box _hover={{ cursor: 'pointer' }} color="gray.400" justifyContent={'center'} w="24px">
      <MdDeleteOutline
        size={24}
        onClick={(e) => {
          e.stopPropagation()
          onClick()
        }}
      />
    </Box>
  )
}

export default DeleteButton
